<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <h1>Large Texas Hospital</h1>
      <h1>Case Study</h1>

      <h2>Leading Healthcare Provider Establishes Secure AWS Landing Zone for Research Data Network</h2>
      <img src="/assets/case-studies/migration-large-texas-hospital-1.jpg" />
      
      <h2>About the Customer:</h2>
      <p>
        A top-tier healthcare organization operating one of the largest pediatric hospitals in the United States, needed to expand their AWS presence with a secure framework for planning workload migrations, particularly focusing on their Research Data Network.
      </p>

      <h2>Customer Challenge:</h2>
      <p>
       The healthcare provider needed to establish a secure, compliant AWS environment to support the migration of their Research Data Network to AWS. Their primary concern was security, requiring a framework that would ensure HIPAA compliance and protect sensitive medical research data. 
      </p>
      <p>The organization needed to implement proper governance, security controls, and network architecture while enabling access to critical AWS services including S3, Redshift, QuickSight, SageMaker, firewalls, and data backup solutions. </p>
      <p> Without addressing these challenges, the organization risked potential security vulnerabilities and compliance issues that could impact their research operations. </p>

      <h2>Partner Solution:</h2>
      <p>Netsync implemented a comprehensive AWS Landing Zone solution using AWS Control Tower and the Landing Zone Accelerator for Healthcare. The solution included:</p>
      <ul>
        <li> Deployment of a multi-account AWS environment with dedicated accounts for audit, logging, and specific workloads.</li>
        <li> Implementation of AWS Organizations with a structured organizational unit (OU) hierarchy for different environments (Production/Non-Production). </li>
        <li> Configuration of Single Sign-On (SSO) integration with Microsoft Entra for centralized identity management.</li>
        <li> Establishment of a secure networking architecture using Transit Gateway as the central hub.</li>
        <li> Implementation of centralized egress with distributed ingress inspection using Palo Alto NGFWv firewalls.</li>
        <li> Deployment of preventive and detective controls through AWS Control Tower guardrails.</li>
        <li> Configuration of AWS services including CloudTrail, CloudWatch, and AWS Config for comprehensive logging and monitoring.</li>
        
      </ul>
      <p>The solution was implemented using Infrastructure as Code (IaC) through Terraform, ensuring consistency and reproducibility across the environment.</p>


      <h2>Results and Benefits:</h2>
      <p>The implementation delivered significant improvements to the organization's cloud operations:</p>
      <ul>
        <li> Reduced deployment time for new AWS accounts from weeks to hours through automated account provisioning.</li>
        <li> Enhanced security posture through implementation of over 200 security controls and guardrails.</li>
        <li> Achieved compliance with healthcare industry requirements through the Landing Zone Accelerator for Healthcare framework.</li>
        <li> Improved operational efficiency by centralizing logging and monitoring across all AWS accounts.</li>
        <li> Established high availability through multi-availability zone deployment across US-East-1 and US-East-2 regions.</li>
        <li> Reduced risk through automated security controls and standardized infrastructure deployment.</li>
        
      </ul>


      <h2>About the Partner:</h2>
      <p>Netsync Network Solutions is an AWS Partner specializing in healthcare, state local education (SLED), higher education, and commercial customers. They provide expertise in Data Center, AI, AWS Cloud, Enterprise Networking, Collaboration/UC, Physical Security, Service Providers, Security, and Managed Services, working with partners including Cisco, Dell, HP, Juniper, and Meraki.</p>

    </div>
  </div>
</div>
